export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-japan-f40bea92fb9aaeea2a925244a73ef302.jpg";